interface BadgeProps {
  label: string;
  color: string;
  textColor?: string;
}

export function Badge({ label, color, textColor = "#fff" }: BadgeProps) {
  return (
    <span
      style={{
        backgroundColor: color,
        color: textColor,
        borderRadius: 4,
        padding: "2px 8px",
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        display: "inline-block",
        lineHeight: 1.6,
      }}
    >
      {label}
    </span>
  );
}
